import { Box } from '@hivebrite/design-system/Box';
import { IconSpacer } from '@hivebrite/design-system/Icon';

import SpacerSettings from 'hb-builder/components/BuilderComponents/single/Spacer/SpacerSettings';
import Drop from 'hb-builder/components/common/Drop';
import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { Wrapper, WrapperBuilder } from 'hb-builder/components/common/Wrapper';
import { useComponentContext, useRendererContext } from 'hb-builder/hooks';
import { getJustifyContent } from 'hb-builder/utils/attributes';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { SpacerItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/spacerItemAttributes';

const componentType = 'single';

const Spacer = () => {
  // This is intentional
};

const RenderBuilder = () => {
  const { item } = useComponentContext();

  const attributes = item?.attributes;

  return (
    <Drop accept={['single']}>
      {() => (
        /* @ts-expect-error untyped */
        <WrapperBuilder
          attributes={attributes}
          style={{
            justifyContent: getJustifyContent(attributes?.horizontalAlign),
          }}
        >
          {({ isDragging }) =>
            isDragging ? null : (
              <Box
                data-testid="builder-component-spacer"
                height={attributes?.spacerHeight}
                width="100%"
              />
            )
          }
        </WrapperBuilder>
      )}
    </Drop>
  );
};

const Render = ({ item }: RenderProps<DocumentItem<SpacerItemAttributes>>) => {
  const { isMobilePreview } = useRendererContext();

  if (!item) {
    return null;
  }
  const { attributes } = item;

  return (
    /* @ts-expect-error untyped */
    <Wrapper
      attributes={attributes}
      componentType={componentType}
      isMobilePreview={isMobilePreview}
    >
      <Box
        data-testid="builder-component-spacer"
        width="100%"
        height={attributes?.spacerHeight}
      />
    </Wrapper>
  );
};

Spacer.componentName = 'Spacer';
Spacer.componentType = componentType;

Spacer.componentLabel = __('Spacer');
Spacer.componentCategory = 'single';
Spacer.componentIcon = () => IconSpacer;

Spacer.canBeDoubleClicked = true;
Spacer.canBeDragged = true;
Spacer.canBeListed = true;
Spacer.canBeSelected = true;

const defaultConfig = () => ({
  height: 94,
});

Spacer.item = () => ({
  attributes: {
    spacerHeight: defaultConfig().height,
  },
  category: Spacer.componentCategory,
  name: Spacer.componentName,
  type: Spacer.componentName,
});

Spacer.toolbar = ['edit', 'drag', 'duplicate', 'delete'];

Spacer.Settings = SpacerSettings;
Spacer.SettingsTabs = [];

Spacer.RenderBuilder = RenderBuilder;
Spacer.Render = Render;

export default Spacer;
